import { ArrivalScheduleModel } from './Models/ArrivalScheduleModel';
import { SecuredAPMProxyClient } from '../../../Core/Api/APMProxy/SecuredAPMProxyClient';
import moment from 'moment';
import { orderBy } from 'lodash';

export class ArrivalScheduleHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetArrivalSchedule(arrivalSchedule: ArrivalScheduleModel): Promise<any | undefined> {
    const client = new SecuredAPMProxyClient();
    client.showLoading = true;
    client.handleGeneralError = false;
    const arrivalDate = !arrivalSchedule.arrivalDateTime
      ? undefined
      : moment(arrivalSchedule.arrivalDateTime)
          .format('YYYYMMDD')
          .toString();
    const shipName = arrivalSchedule['shipName'];

    return client.getVesselSchedule(shipName, arrivalDate).then(x => {
      return orderBy(x.data, x => x.arrivalDateTime);
    });
  }
}
